<template>
  <el-autocomplete size="mini"
                   :value="time"
                   @input="timeInput"
                   :fetch-suggestions="querySearch"
                   :placeholder="placeHolder"
                   @select="handleSelect">
    <i slot="prefix"
       class="el-input__icon el-icon-time"></i>
  </el-autocomplete>
  <!-- fetch-suggestions 是 返回输入建议的一个方法。有两个参数，一个是输入值，一个是返回值 -->
</template>

<script>
export default {
  name: 'time-input',
  data() {
    return {
      time: this.select_time,
    }
  },
  props: {
    placeHolder: {
      type: String,
      default: '请输入时间',
    },
    select_time: { type: String, default: '' }, // 选择的时间
    time_list: {
      type: Array,
      default: [
        { value: '08:00' },
        { value: '08:30' },
        { value: '09:00' },
        { value: '09:30' },
        { value: '10:00' },
        { value: '10:30' },
        { value: '11:00' },
        { value: '12:00' },
        { value: '13:00' },
        { value: '13:30' },
        { value: '14:00' },
        { value: '14:30' },
        { value: '15:00' },
        { value: '16:00' },
        { value: '17:00' },
      ],
    },
  },
  watch: {
    select_time(newValu) {
      this.time = newValu
    },
  },
  methods: {
    timeInput(event) {
      this.time = event
      // console.log(this.time);
      this.$emit('timeChange', this.time)
    },
    handleSelect(item) {
      // console.log(item);
    },
    querySearch(queryString, cb) {
      // 定义一个 时间列表
      var time_list = this.time_list
      // 表达式1:time_list.filter(this.createFilter(queryString))
      // 表达式2:time_list
      // 如果有queryString 则 跟 表达式1  和 表达式2 匹配，符合1 则返回1，符合2 则返回2
      var results = queryString
        ? // filter() 遍历数组 ，返回满足条件的元素。
          time_list.filter(this.createFilter(queryString))
        : time_list
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    // 过滤函数，输入值 返回一个函数
    // 函数的内容：restaurant 是一个返回值
    createFilter(queryString) {
      return (time) => {
        return (
          // toLowerCase() 字符串值转为小写形式
          //  indexOf（）返回调用它的 String 对象中第一次出现的指定值的索引
          time.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        )
      }
    },
  },
}
</script>

<style>
</style>